module.exports = __webpack_public_path__ + "img/140.53631b9f.jpg";